// TSS vite/04 §"Endpoint paths". baseURL already includes /api/v1.

export const salePaths = {
    list:      ()   => 'admin/sales',
    detail:    (id) => `admin/sales/${id}`,
    reconcile: (id) => `admin/sales/${id}/reconcile`,
    // Abonos — sub-recurso de una venta (Q-199).
    payments:      (id)      => `admin/sales/${id}/payments`,
    paymentDetail: (id, pid) => `admin/sales/${id}/payments/${pid}`,
};
